<template>
  <div :id="componentId">
    <div v-if="productData.HeadingTitle" class="row">
      <div v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }">
        <h1
          v-if="productData.HeadingTitle.includes('</')"
          class="before-after-heading"
          v-html="productData.HeadingTitle"
        ></h1>
        <h1 v-else class="before-after-heading">{{ productData.HeadingTitle }}</h1>
      </div>
    </div>
    <div class="row before-after-container">
      <div
        v-for="(product, index) in productData.BeforeAfterComparisonSlide"
        :key="index"
        class="col-xs-12 col-sm-6 col-md-4"
      >
        <div class="before-after-wrapper-content">
          <div v-if="product.Title" v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }">
            <h2
              v-if="product.Title.includes('</')"
              class="before-after-title"
              v-html="product.Title"
            ></h2>
            <h2 v-else class="before-after-title">{{ product.Title }}</h2>
          </div>

          <div
            v-if="product.Description"
            v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
          >
            <span
              v-if="product.Description.includes('</')"
              class="before-after-description"
              v-html="product.Description"
            />
            <span v-else class="before-after-description">{{ product.Description }}</span>
          </div>

          <before-after
            v-if="product.BeforeImage.Src && product.AfterImage.Src"
            :title="product.Title"
            :before-label="product.BeforeText"
            :after-label="product.AfterText"
            :carosel-color="productData.CursorHexCode"
          >
            <template #before="beforeProps">
              <img
                width="500"
                :style="beforeProps.dimensions"
                class="lazyload"
                :data-src="product.BeforeImage.Src"
                alt="before"
                @@load="beforeProps.onresize"
              />
            </template>
            <template #after="afterProps">
              <img
                width="500"
                :style="afterProps.dimensions"
                class="lazyload"
                :data-src="product.AfterImage.Src"
                alt="after"
                @@load="afterProps.onresize"
              />
            </template>
          </before-after>
        </div>
      </div>
    </div>
    <div
      v-if="productData.Text"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="row"
    >
      <span v-if="productData.Text.includes('</')" class="before-after-last-line-text">{{
        productData.Text
      }}</span>
      <span v-else class="before-after-last-line-text">{{ productData.Text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'before-after-block',
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'before-after',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
  },
};
</script>
